import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Check } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-green relative overflow-hidden" data-id="element-157" data-mp="3uei0rbisni08">
      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-158" data-mp="c7k6g0aiwrpx">
        <h2 className="text-3xl md:text-5xl font-serif font-bold mb-12 text-cream leading-tight" data-id="element-159" data-mp="84nuutjehvvh">
          El próximo lunes podés seguir buscando. <br data-id="element-160" data-mp="m3dpm2iqzjgo" />
          <span className="text-gold" data-id="element-161" data-mp="m2vlkjpug0y7">
            O podés entrar al taller con todo listo.
          </span>
        </h2>

        <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-green-dark p-8 rounded-2xl border border-green-light/30" data-id="element-162" data-mp="vurvqt57fhis">
          {['Buscando información dispersa en cuatro lugares distintos.', 'Armando una evaluación la noche anterior.', 'Explicando un proceso técnico sin los parámetros correctos a mano.', 'Terminando el año con la sensación de que los alumnos aprendieron temas sueltos pero nunca vieron el proceso completo.'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-163" data-mp="2h37x6x1xaiyk" data-mpi={i}>
              <span className="text-terracota mt-1" data-id="element-164" data-mp="2h5koi0tkm5oa">▸</span>
              <span className="text-cream-light" data-id="element-165" data-mp="2m21bgrp1adzs">{item}</span>
            </div>)}
        </div>

        <p className="text-2xl font-bold text-gold mb-6" data-id="element-166" data-mp="2r2p0j7tpckrd">
          O podés elegir diferente.
        </p>

        <div className="text-cream-light text-lg space-y-4 mb-16 max-w-3xl mx-auto" data-id="element-167" data-mp="2v2zh1ef4etkh">
          <p data-id="element-168" data-mp="301ar9q9bv638">
            El Mega Pack no te convierte en mejor docente.{' '}
            <strong className="text-cream" data-id="element-169" data-mp="34t27p7yrrvfn">Vos ya sos un buen docente.</strong>
          </p>
          <p data-id="element-170" data-mp="39sybb63k1kuo">
            Lo que hace el Mega Pack es darte la estructura, las actividades,
            las evaluaciones y los proyectos para que eso se note en cada
            práctica de taller.
          </p>
          <p data-id="element-171" data-mp="3isblk0zi6dgg">
            Te devuelve el tiempo que perdés planificando. Te da la seguridad de
            entrar al aula con todo preparado.
          </p>
          <p data-id="element-172" data-mp="1jlz3q7axjrq1">
            Les muestra a tus alumnos el proceso completo: de la materia prima
            al producto terminado, envasado y calculado.
          </p>
        </div>

        <div className="bg-cream rounded-3xl p-8 md:p-12 shadow-xl border border-gold/50 text-ink" data-id="element-173" data-mp="1shyec1plmp82">
          <h3 className="text-2xl font-bold text-green mb-6 text-center border-b border-cream-dark pb-6" data-id="element-174" data-mp="1nong2oyurgrr">
            Todo lo que incluye:
          </h3>

          <div className="grid md:grid-cols-2 gap-x-8 gap-y-3 mb-10 text-left" data-id="element-175" data-mp="1xgjey28rjax1">
            {['Tomo 1 — Las Bases del Taller Profesional', 'Tomo 2 — De la Materia Prima a la Conservación', 'Tomo 3 — Tecnología de Lácteos y Cárnicos', 'Tomo 4 — Del Envase al Consumidor', 'Tomo 5 — Del Taller al Emprendimiento', 'Bono 1 — Inocuidad y Seguridad Alimentaria', 'Bono 2 — Métodos de Conservación', 'Bono 3 — Materias Primas y Calidad', 'Bono 4 — Procesos Alimentarios Paso a Paso', 'Bono 5 — Diccionario Profesional Técnico', 'Banco de paquete de actividades adicionales', 'Banco de Evaluaciones', 'Garantía de 7 días', 'Pago en tu moneda local', 'Acceso inmediato', 'Formato PDF listo para usar'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-176" data-mp="3ffhb04kwr2ly" data-mpi={i}>
                <Check size={16} className="text-terracota shrink-0" data-id="element-177" data-mp="3kd93azpgsqqo" />
                <span className="text-sm font-medium" data-id="element-178" data-mp="36d821j5afhao">{item}</span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-179" data-mp="3bct442fr85rm">
            <div className="mb-8 p-6 bg-warmwhite rounded-xl border border-cream-dark italic text-slate text-lg" data-id="element-180" data-mp="3bdvum9960670">
              "El mejor momento para tener este material era al inicio del año.
              <br data-id="element-181" data-mp="19ic0gvj3buca" />
              <span className="text-terracota font-bold not-italic" data-id="element-182" data-mp="35nje0k48fjlr">
                El segundo mejor momento es hoy.
              </span>
              "
            </div>

            <p className="text-4xl font-bold text-green mb-2" data-id="element-183" data-mp="30p9gi2v1c6wz">USD 19,90</p>
            <p className="text-sm text-terracota font-medium mb-8" data-id="element-184" data-mp="2vo29w74mpdrw">
              Precio promocional disponible por tiempo limitado
            </p>

            <Button href="#pricing" variant="terracota" className="mb-6 w-full sm:w-auto" data-id="element-185" data-mp="2mooyh8wy2f4j">
              QUIERO MI MEGA PACK AHORA
            </Button>

            <div className="flex flex-wrap justify-center gap-4 text-xs text-slate font-medium" data-id="element-186" data-mp="2cym9djsy1lbh">
              <span data-id="element-187" data-mp="2802lhdushzgh">✅ Garantía de 7 días</span>
              <span data-id="element-188" data-mp="28140ftexf63h">🔒 Pago seguro</span>
              <span data-id="element-189" data-mp="23y7lqdsibu4t">⚡ Acceso inmediato</span>
              <span data-id="element-190" data-mp="23x5y79ub1f67">💱 Pagás en tu moneda local</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}